import React from 'react';
import { Row } from 'components/Containers/Row/Row';
import { Disclaimer } from 'components/AdvertiserToolTip/AdvertiserToolTip';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { PARTNER_TEXT_DISCLAIMER } from 'types/morph.pagePosition.constants';
import { useViewModule, useSeenModulePixel } from 'hook/helper.hook';

const PartnerTextDisclaimer = props => {
  const trackingAtr = getViewModuleTrackingAttributes(
    PARTNER_TEXT_DISCLAIMER,
    props.modulePosition,
  );

  useViewModule(trackingAtr);

  const seenPixel = useSeenModulePixel(trackingAtr);
  return (
    <>
      <Row fullWidth className={'m-padLR0 noPadMobile'}>
        {seenPixel}
        <Disclaimer showPartnerText />
      </Row>
    </>
  );
};

export default PartnerTextDisclaimer;
